import { PaymentFilterScreen } from '@/modules/payments';

export default PaymentFilterScreen;
